import { createActions, createReducer } from 'reduxsauce'
import FaleConoscoService from '_/servicos/FaleConoscoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaFaleConoscoInicio: [],
    buscaFaleConoscoSucesso: ['faleConosco'],
    buscaFaleConoscoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaFaleConosco = () => {
    return dispatch => {
        dispatch(Creators.buscaFaleConoscoInicio())

        let serv = new FaleConoscoService()

        return serv
            .getInformacoes()
            .then(response => dispatch(Creators.buscaFaleConoscoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaFaleConoscoErro(error)))
    }
}

const buscaFaleConoscoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaFaleConoscoSucesso = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaFaleConoscoErro = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.faleConosco, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_FALE_CONOSCO_INICIO]: buscaFaleConoscoInicio,
    [Types.BUSCA_FALE_CONOSCO_ERRO]: buscaFaleConoscoSucesso,
    [Types.BUSCA_FALE_CONOSCO_SUCESSO]: buscaFaleConoscoErro,
})
